import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';

import map from 'lodash/map';
import flatMap from 'lodash/flatMap';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import {
  SearchIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';

import {
  getUrl,
  getTarget,
  isExternalLink,
  doesOpenInNewTab
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import LanguageSelector from 'zoomforth_component_lib/translations_language_selector_container.jsx';


const isSubmenuItemSelected = (submenuItem, currentMenuItem, lastClickedSubmenuItemId) => (
  lastClickedSubmenuItemId &&
  submenuItem.appAction.subpageId === currentMenuItem.appAction.subpageId &&
  lastClickedSubmenuItemId === submenuItem.id
);

class MobileNavigationMenu_ViewerVersion2 extends Component {
  render() {
    const {
      isOpen,
      currentSubpage,
      isInPageSearchEnabled,
      menuItems,
      submenuItemsBySubpageId,
      lastClickedSubmenuItemId,
      isTranslationsEnabled,
      appliedLanguages,
      currentIso,
      defaultLanguageIso,
      onLanguageChange,
      onMobileMenuItemClick,
      onMobileSubmenuItemClick,
      onSearchInPageClick
    } = this.props;

    if(!isOpen){
      return null;
    }

    return (
      <FocusTrap focusTrapOptions={{ allowOutsideClick: true }}>
        <nav
          role="dialog"
          id="dialog-mobile-nav"
          className="mobile-navigation-view"
          aria-labelledby="dialog-mobile-nav__label"
          aria-modal="true"
        >
          <div className="nav-menu-title-wrapper">
            <h2 id="dialog-mobile-nav__label" className="nav-menu-title">
              Menu
            </h2>
          </div>
          <ul className="mobile-navigation-menu-list">
            {
              isInPageSearchEnabled &&
              <div className="in-page-search-start-menu-item__container">
                <button className="menu-item in-page-search-start-menu-item" onClick={onSearchInPageClick}>
                  <SearchIcon /> Search in site...
                </button>
              </div>
            }
            {flatMap(menuItems, (menuItem) =>
              [
                <li
                  key={`nav-sec-${menuItem.id}`}
                  className={classNames(
                    'menu-item',
                    `mobile-menu-item-${menuItem.id}`,
                    { 'selected': menuItem.appAction.subpageId === currentSubpage.id }
                  )}
                >
                  <a
                    aria-current={menuItem.appAction.subpageId === currentSubpage.id ? 'page' : null}
                    onClick={() => { onMobileMenuItemClick(menuItem); }}
                    target={getTarget(menuItem.appAction)}
                    href={getUrl(menuItem.appAction)}
                    className={`action-nav-link mobile-menu-item-${menuItem.id}`}
                  >
                    {menuItem.title} {
                      (isExternalLink(menuItem.appAction) || doesOpenInNewTab(menuItem.appAction)) &&
                        <span>(Opens in a new window)</span>
                    }
                  </a>
                </li>

              ].concat(

                !menuItem.isPrimaryForSubpage ?
                  []
                  : submenuItemsBySubpageId[menuItem.appAction.subpageId] &&
                  <ul key={`nav-sec-${menuItem.id}-subsec`}>
                    {map(submenuItemsBySubpageId[menuItem.appAction.subpageId], submenuItem =>
                      <li key={`nav-sec-${menuItem.id}-subsec-${submenuItem.id}`} className="menu-item is-subsection">
                        <a
                          onClick={(e) => {
                            if (lastClickedSubmenuItemId === submenuItem.id) {
                              e.preventDefault();
                            }
                            onMobileSubmenuItemClick(submenuItem);
                          }}
                          target={getTarget(submenuItem.appAction)}
                          href={getUrl(submenuItem.appAction)}
                          className={classNames(`action-nav-link mobile-submenu-item-${submenuItem.id}`, {
                            selected: isSubmenuItemSelected(submenuItem, menuItem, lastClickedSubmenuItemId)
                          })}
                        >
                          {submenuItem.title} {
                            (isExternalLink(menuItem.appAction) || doesOpenInNewTab(menuItem.appAction)) &&
                              <span>(Opens in a new window)</span>
                          }
                        </a>
                      </li>
                    )}
                  </ul>
              )
            )}
          </ul>

          {
            isTranslationsEnabled &&
              <LanguageSelector
                currentIso={currentIso}
                defaultLanguageIso={defaultLanguageIso}
                appliedLanguages={appliedLanguages}
                onLanguageChange={onLanguageChange}
              />
          }
        </nav>
      </FocusTrap>
    );
  }
}

MobileNavigationMenu_ViewerVersion2.propTypes = {
  currentSubpage: PropTypes.object,
  menuItems: PropTypes.array,
  submenuItemsBySubpageId: PropTypes.object,
  lastClickedSubmenuItemId: PropTypes.string
};

class MobileNavigationMenu_ViewerVersion1 extends Component {

  render() {
    const {
      currentSubpage,
      isInPageSearchEnabled,
      menuItems,
      submenuItemsBySubpageId,
      lastClickedSubmenuItemId,
      isTranslationsEnabled,
      appliedLanguages,
      currentIso,
      defaultLanguageIso,
      onLanguageChange,
      onMobileMenuItemClick,
      onMobileSubmenuItemClick,
      onSearchInPageClick
    } = this.props;

    return (
      <nav className="mobile-navigation-view">
        <div className="nav-menu-title-wrapper">
          <div className="nav-menu-title">
            Menu
          </div>
        </div>
        <div className="mobile-navigation-menu-list">
          {
            isInPageSearchEnabled && 
            <div className="menu-item in-page-search-start-menu-item" onClick={onSearchInPageClick}>
              <SearchIcon /> Search in site...
            </div>
          }
          { flatMap(menuItems, menuItem => 
            [
              <div 
                key={`nav-sec-${menuItem.id}`} 
                className={classNames(
                  'menu-item', 
                  `mobile-menu-item-${menuItem.id}`, 
                  { 'selected': menuItem.appAction.subpageId === currentSubpage.id }
                )}
              >
                <a 
                  onClick={()=> { onMobileMenuItemClick(menuItem); }}
                  target={getTarget(menuItem.appAction)}
                  href={getUrl(menuItem.appAction)}
                  className={`action-nav-link mobile-menu-item-${menuItem.id}`}
                >
                  { menuItem.title }
                </a>
              </div>

            ].concat(

              !menuItem.isPrimaryForSubpage ?
                []
              :
                map(submenuItemsBySubpageId[menuItem.appAction.subpageId], submenuItem => 
                  <div key={`nav-sec-${menuItem.id}-subsec-${submenuItem.id}`} className="menu-item is-subsection">
                    <a 
                      onClick={(e)=> { 
                        if (lastClickedSubmenuItemId === submenuItem.id) {
                          e.preventDefault();
                        }
                        onMobileSubmenuItemClick(submenuItem); 
                      }}
                      target={getTarget(submenuItem.appAction)}
                      href={getUrl(submenuItem.appAction)}
                      className={classNames(`action-nav-link mobile-submenu-item-${submenuItem.id}`, { 
                        selected: isSubmenuItemSelected(submenuItem, menuItem, lastClickedSubmenuItemId)
                      })}
                    >
                      { submenuItem.title }
                    </a>
                  </div> 
                )
            )
          )}
        </div>

        {
          isTranslationsEnabled &&
            <LanguageSelector
              currentIso={currentIso}
              defaultLanguageIso={defaultLanguageIso}
              appliedLanguages={appliedLanguages}
              onLanguageChange={onLanguageChange}
            />
        }
      </nav>
    );
  }
}

MobileNavigationMenu_ViewerVersion1.propTypes = {
  currentSubpage: PropTypes.object,
  menuItems: PropTypes.array,
  submenuItemsBySubpageId: PropTypes.object,
  lastClickedSubmenuItemId: PropTypes.string
};

const MobileNavigationMenu = (props) => (
  <SiteViewerVersionComponentSelector>
    <MobileNavigationMenu_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <MobileNavigationMenu_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default MobileNavigationMenu;
